
import styled from 'styled-components';
import Typography from 'app/ui/components/atoms/typography';

export const ResourceListDescription = styled(Typography)`
  margin-top: -${({ theme: { spacing } }) => spacing(4)};
`;
